// Script to display the selected radio button value for each color picker

document.addEventListener('DOMContentLoaded', function() {
  // Function to update the display of selected color value
  function updateSelectedColorDisplay(groupName, displayId) {
    // Find all radio inputs with the given name
    const radioButtons = document.querySelectorAll(`input[type="radio"][name="${groupName}"]`);
    
    // Find the display element
    const displayElement = document.getElementById(displayId);
    
    if (!displayElement) return; // Skip if the display element doesn't exist
    
    // Initial update - show the currently selected value
    const checkedButton = document.querySelector(`input[type="radio"][name="${groupName}"]:checked`);
    if (checkedButton) {
      displayElement.textContent = checkedButton.value;
    }
    
    // Add event listeners to all radio buttons in this group
    radioButtons.forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.checked) {
          displayElement.textContent = this.value;
        }
      });
    });
  }
  
  // Map of property name patterns to display element IDs
  const propertyToDisplayMap = [
    { property: 'properties[Schriftfarbe]', display: 'schriftfarbe' },
    { property: 'properties[Dekofarbe-1]', display: 'dekofarbe-1' },
    { property: 'properties[Dekofarbe-2]', display: 'dekofarbe-2' }
  ];
  
  // Initialize each color picker group if it exists
  propertyToDisplayMap.forEach(mapping => {
    updateSelectedColorDisplay(mapping.property, mapping.display);
  });
  
  // Optional: Handle dynamic content changes
  // If modules are loaded dynamically after page load, you may need to 
  // call the initialization function again or use a MutationObserver
  
  // Example of using MutationObserver (uncomment if needed)
  /*
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Re-initialize the color pickers
        propertyToDisplayMap.forEach(mapping => {
          updateSelectedColorDisplay(mapping.property, mapping.display);
        });
      }
    });
  });
  
  // Observe the container element where dynamic modules are added
  const container = document.querySelector('.your-container-selector');
  if (container) {
    observer.observe(container, { childList: true, subtree: true });
  }
  */
});